import React, { useState, useEffect } from "react";
import { Tooltip, useMediaQuery, TextField, Select, Typography, Grid } from '@mui/material';
import { useHistory } from "react-router-dom";
import './AddEditEvent.css';
import { useForm } from "react-hook-form";
import { styled, useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import { FORM_MODES } from "../../helpers/Constants";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useStoreActions, useStoreState } from "easy-peasy";
import { useLocation } from 'react-router'
import { tooltipClasses } from '@mui/material/Tooltip';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';

export default function AddEditEvent(props) {
    const history = useHistory();
    const { mode, id } = props.location.state || '';
    const [status, setStatus] = useState(null);

    const [locations, setLocations] = useState();

    const [locationValue, setLocationValue] = useState();
    const [clientValue, setClientValue] = useState();
    const [clients, setClients] = useState();
    const [currentPageData, setCurrentPageData] = useState([]);
    const [stateId, setStateId] = useState(null);
    const [openProgressBar, setOpenProgressBar] = useState(true);
    const [person, setPerson] = useState(null);
    const people = useStoreState((state) => state.people);
    const [licenseId, setLicenseId] = useState();
    const location = useLocation();

    // ** States   
    const [hasResult, setHasResult] = useState(false);
    const [error, setError] = useState(null);
    const [createEvent, setCreateEvent] = useState(false);
    const [EventSearchBy, setEventSearchBy] = useState(null);

    useEffect(() => {
        getEvent();
    }, [location.key]);


    const [open, setOpen] = useState(false);
    const handleCloseProgressBar = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const getEvent = async () => {
        handleOpen();
        let tempId = id;
        if (mode == FORM_MODES.add)
            tempId = 0;
        await fetch(`/api/Event/GetEventById?id=${tempId}`)
            .then(response => response.json())
            .then(data => {
                setCurrentPageData([data]);
                setFilteredLocations(data?.locations.$values);
                setLocations(data?.locations.$values);
                setClients(data?.clients.$values);
                setFilteredClients(data?.clients.$values);
                setLocationValue(data?.events.$values[0].eventLocation);
                setClientValue(data?.events.$values[0].client);

                if (mode == FORM_MODES.edit) {
                    document.querySelector('input[placeholder="Enter Name of event"]').value = data?.events.$values[0].eventName;
                    document.querySelector('input[placeholder="Enter Start Date"]').value = dayjs(data?.events.$values[0].eventDate).format('YYYY-MM-DD');
                    document.querySelector('input[placeholder="Enter End Date"]').value = dayjs(data?.events.$values[0].eventEndDate).format('YYYY-MM-DD');
                    document.querySelector('textarea').value = data?.events.$values[0].note;
                }
            })
            .catch(error => {
                console.error('Error fetching License data: ', error);
            });
        setOpenProgressBar(false);
    };

    useEffect(() => {
        getEvent();
    }, [id]);

    const handleMainMenu = () => {
        history.push({ pathname: '/EventManager' });
    }
    // const [locations, setLocations] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [filteredClients, setFilteredClients] = useState([]);

    const handleLocationChange = (e) => {
        const value = e.target.value.toLowerCase();
        setFilteredLocations(locations.filter(location => location.toLowerCase().includes(value)));
    };

    const handleClientChange = (e) => {
        const value = e.target.value.toLowerCase();
        setFilteredClients(clients.filter(client => client.toLowerCase().includes(value)));
    }

    const handleEvent = () => {
        const eventName = document.querySelector('input[placeholder="Enter Name of event"]')?.value;
        const location = locationValue;
        const client = clientValue;
        const startDate = document.querySelector('input[placeholder="Enter Start Date"]')?.value;
        const endDate = document.querySelector('input[placeholder="Enter End Date"]')?.value;
        const note = document.querySelector('textarea')?.value;
        const currentDefaultEventId = localStorage.getItem('defaultEventId');
        const params = {
            eventName,
            location,
            startDate,
            endDate,
            client,
            note
        };
        if (note.length > 5000) {
            setError("Note must be less than 5000 characters.");
            return;
        }

        if (eventName && location && startDate && endDate && client) {
            if (
                mode == FORM_MODES.edit &&
                currentDefaultEventId == id &&
                dayjs(endDate).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
            ) {
                localStorage.setItem('defaultEventId', "");
            }

            if (new Date(endDate) >= new Date(startDate)) {
                mode == FORM_MODES.add ? handleAddEvent(params) : handleEditEvent(params);
            } else {
                setError("End date must be after start date.");
            }
        } else {
            setError("Please fill in all required fields.");
        }
    }

    const handleAddEvent = (params) => {
        setHasResult(false);
        setOpenProgressBar(true);
        setError(null);

        fetch(`api/Event/CreateNewEvent`, {
            method: 'POST',
            body: JSON.stringify({
                "eventName": params.eventName,
                "eventLocation": params.location,
                "eventDate": params.startDate,
                "eventEndDate": params.endDate,
                "client": params.client,
                "note": params.note,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then((data) => {
                localStorage.setItem('EventSearchBy', EventSearchBy);
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                }
                else {
                    setError("No results found");
                    setCreateEvent(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster Id: " + params.pilotId);
                }
                else {
                    setError("An error occurred, please try again later.");
                }
                setOpenProgressBar(false);
            });
    }

    const handleEditEvent = (params) => {
        setHasResult(false);
        setOpenProgressBar(true);
        setError(null);

        fetch(`api/Event/UpdateEvent`, {
            method: 'PUT',
            body: JSON.stringify({
                "id": id,
                "eventName": params.eventName,
                "eventLocation": params.location,
                "eventDate": params.startDate,
                "eventEndDate": params.endDate,
                "client": params.client,
                "note": params.note,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    localStorage.setItem('EventSearchBy', EventSearchBy);
                }
                else {
                    setError("No results found");
                    setCreateEvent(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster Id: " + params.pilotId);
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }

    return (
        <>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={10} md={10}>
                    <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                        <div>
                            <div className="text-center mx-auto space-y-4 p-4">
                                <h2 className="text-xl text-pink-800 font-bold">Please verify the details of the event, then select '{mode == FORM_MODES.add ? 'Create' : 'Save'} Event'</h2>
                            </div>
                            <div class="flex justify-between items-start space-x-4">
                                <div class="w-1/2">
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>Name of event:</span> <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="text" class="border rounded w-full p-2 mb-4" placeholder="Enter Name of event" maxLength="100" />
                                </div>
                                <div class="w-1/2">
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>Location:</span> <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Autocomplete
                                        freeSolo
                                        fullWidth
                                        value={[locationValue]} // Controlled value
                                        onChange={(event, newValue) => {
                                            setLocationValue(newValue); // Update selected value                                            
                                        }}
                                        sx={(theme) => ({
                                            display: 'inline-block',
                                            '& input': {
                                                height: 9,
                                                bgcolor: 'background.paper',
                                                color: theme.palette.getContrastText(theme.palette.background.paper),
                                            },
                                        })}
                                        options={filteredLocations} // Options fetched from the database
                                        renderInput={(params) => (
                                            <TextField  {...params} sx={{ "& fieldset": { border: '1px solid #E8E4C9' } }} onChange={(e) => setLocationValue(e.target.value)} />
                                        )}
                                    />
                                </div>
                            </div>
                            <div class="grid grid-cols-3 gap-4 content-center">
                                <div>
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>Start Date:</span> <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="border rounded w-full p-2 mb-4" placeholder="Enter Start Date" id="startDate" maxLength="10" />
                                </div>
                                <div>
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>End Date:</span> <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="border rounded w-full p-2 mb-4" placeholder="Enter End Date" id="endDate" maxLength="10" />
                                </div>
                                <div>
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>Client:</span><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Autocomplete
                                        freeSolo
                                        fullWidth
                                        value={[clientValue]} // Controlled value
                                        onChange={(event, newValue) => {
                                            setClientValue(newValue); // Update selected value                                            
                                        }}
                                        sx={(theme) => ({
                                            display: 'inline-block',
                                            '& input': {
                                                height: 9,
                                                bgcolor: 'background.paper',
                                                color: theme.palette.getContrastText(theme.palette.background.paper),
                                            },
                                        })}
                                        options={filteredClients} // Options fetched from the database
                                        renderInput={(params) => (
                                            <TextField {...params} sx={{ "& fieldset": { border: '1px solid #E8E4C9' } }} onChange={(e) => setClientValue(e.target.value)} />
                                        )}
                                    />
                                </div>
                            </div>
                            <div class="grid grid-cols-1 content-center space-y-4 mb-4">
                                <div>
                                    <label className="block mb-2 font-semibold">
                                        <span style={{ color: 'black' }}>Note:</span>
                                    </label>
                                    <textarea maxLength="5000" class="peer h-full  border rounded w-full resize-none rounded-[7px] px-3 py-2.5 font-sans font-normal outline outline-0 focus:outline-0"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-center">
                            {error && <div className="text-red-500">{error}</div>}
                        </div>
                        {hasResult ?
                            <>
                                <div class="flex justify-center py-2 space-x-4">
                                    <div className="flex flex-col items-center justify-center p-15 space-y-4">
                                        <Typography variant="h4" className='text-green-500'>Successfully {mode == FORM_MODES.add ? 'Created!' : 'Updated!'} </Typography>
                                    </div>
                                </div>
                                <div class="flex justify-center py-2 space-x-4">
                                    <button className="bg-red-900 text-white rounded-full px-7 py-2" onClick={handleMainMenu}>
                                        Main Menu
                                    </button>
                                </div>
                            </>
                            :
                            <>
                                {/* <div class="grid grid-cols-3 items-center py-0"> */}
                                {/* <div>
                                        <label className="block mb-2 font-semibold">
                                            <span style={{ color: 'black' }}>Search By:</span>
                                        </label>
                                    </div>
                                    <div></div>
                                    <div></div>
                                    <div class="flex justify-start items-left space-x-4">
                                        <label>
                                            <input
                                                type="radio"
                                                name="eventType"
                                                value="pilotIdOrPhone"
                                                onChange={(e) => handleEventSearchBy(e.target.value)}
                                                style={{ accentColor: 'lightblue' }}
                                            />
                                            Pilot ID or Phone
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="eventType"
                                                value="all"
                                                onChange={(e) => handleEventSearchBy(e.target.value)}
                                                style={{ accentColor: 'lightblue' }}
                                            />
                                            All Details
                                        </label>
                                    </div> */}
                                <div class="flex justify-center items-center space-x-4">
                                    <button className="bg-red-900 text-white rounded-full px-16 py-2" onClick={handleEvent}>
                                        <div class="flex space-x-2">
                                            <div>{mode == FORM_MODES.add ? 'Create' : 'Save'} Event</div>
                                        </div>
                                    </button>
                                    <button className="bg-red-900 text-white rounded-full px-7 py-2" onClick={handleMainMenu}>
                                        Main Menu
                                    </button>
                                </div>
                                {/* </div> */}
                            </>
                        }
                    </div>
                </Grid>
            </Grid >
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}